<div class="grid-fluid bg-surface-highlight">
  <div class="cell">
    <div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xbig">
      <div class="cell cell-large-col-span-12 flex flex-justify-center flex flex-column text-center">
        <h1 class="display-small margin-bottom-small">{{ data.settings?.heading }}</h1>
        <div
          id="trustbox-rating-2"
          class="trustpilot-widget"
          data-locale="en-GB"
          data-style-height="40px"
          data-style-width="100%"
          data-theme="light"
          data-stars="3,4,5"
          data-tags="SelectedReview"
          data-schema-type="Organization">
        </div>
      </div>
      <div *ngFor="let review of data.settings?.reviews" class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-medium bg-white open-section">
        <img *ngFor="let star of [].constructor(review.rating)" src="/assets/svgs/icons/star.svg" height="20" width="20" class="svg icon xsmall">
        <h4 class="text-blackMatte margin-bottom-small margin-top-xsmall">{{ review.title }}</h4>
        <p class="text-small text-darkGray margin-top-none margin-bottom-small">{{ review.content }}</p>
        <div class="strong-small text-blackMatte">{{ review.author }}</div>
      </div>
  </div>
</div>